import CampaignComponent from "../../modules/campaign/CampaignPage";

export default function Campaigns() {
    return <CampaignComponent role="organization" />;
}